const idByLocale = {
    'es-CO': 50,
    pt: 176,
    fr: 1,
    en: 228,
    es: 3
}

export { idByLocale }
